export default "__VITE_ASSET__xFVHdsQP__"